import tw, { css, styled } from 'twin.macro';
import { Tooltip } from 'react-tooltip';

export const SVG = styled.svg<{ theme: Queries.kontent_item_tooltip_elements_theme_enum }>`
  ${tw`inline`}
  ${tw`mt-[-1px]`}
  ${({ theme }) => {
    switch (theme) {
      case 'dark':
        return tw`fill-primary-p1`;
      case 'light':
        return tw`fill-neutrals-n6`;
    }
  }}
`;

export const Wrapper = styled.span`
  ${tw`relative`}
`;

export const Content = styled(Tooltip)<{ liCount: number; ulCount: number }>`
  &.tooltip {
    ${tw`font-inter font-regular`}
    ${tw`text-left`}
    ${tw`p-[12px]`}
    ${tw`opacity-100`}
    ${tw`z-10`}
    ${tw`absolute`}
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      ${tw`font-medium`}
      ${tw`mb-[4px]`}
    }

    &.theme-dark {
      ${tw`bg-primary-p1`}
      ${tw`text-neutrals-n1`}
      &:after {
        ${tw`border-primary-p1`}
      }
    }

    &.theme-light {
      ${tw`bg-neutrals-n1`}
      ${tw`text-neutrals-n9`}
      &:after {
        ${tw`border-neutrals-n1`}
      }
    }

    ${({ liCount }) => (liCount > 0 ? tw`max-w-[700px]` : tw`max-w-[320px]`)}
    & > ul, & > ol {
      & ul,
      & ol {
        ${tw`mx-2`}
        & > li {
          ${tw`float-none`}
          ${tw`w-[100%]`}
        }
      }

      & > li:has(ul, ol) {
        ${tw`block`}
        ${tw`float-left`}
        ${tw`w-[33%]`}
        ${tw`whitespace-normal`}
        ${({ ulCount }) => {
          switch (true) {
            case ulCount <= 3:
              return tw`w-[50%]`;
            case ulCount <= 4:
              return tw`w-[33%]`;
            case ulCount <= 5:
              return tw`w-[25%]`;
          }
        }}
      }

      &:not(:has(ul, ol)) {
        li {
          ${tw`pr-2`}
        }

        ${tw`ml-[20px]`}
        ${({ liCount }) => {
          switch (true) {
            case liCount <= 6:
              return css`
                column-count: 1;
              `;
            case liCount <= 12:
              return css`
                column-count: 2;
              `;
            case liCount > 12:
              return css`
                column-count: 3;
              `;
          }
        }}
      }
    }
  }

  ul {
    ${tw`list-disc`}
    ul {
      ${tw`list-[circle]`}
    }
  }

  ol {
    ${tw`list-decimal`}
    ol {
      ${tw`list-[upper-roman]`}
    }
  }
`;
